import { Component, Input } from '@angular/core';
import i18next from 'i18next';
import { Translate } from '../../utils/translate';

@Component({
  selector: 'app-booking-vehicle-data',
  templateUrl: './booking-vehicle-data.component.html',
  styleUrls: ['./booking-vehicle-data.component.scss']
})
export class BookingVehicleDataComponent {
  @Input() bookingData?: any;

  noComments = i18next.t('noObservations');

  constructor(public translate: Translate) {}
}
